import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { Box } from '@mui/system';

interface SafeSvgDataRendererComponentProps {
    svgContent: string;
    width: number;
    height: number;
}

export const SafeSvgDataRendererComponent: React.FC<SafeSvgDataRendererComponentProps> = ({
                                                                                              svgContent,
                                                                                              width = 40,
                                                                                              height = 40,
                                                                                          }) => {
    const dataUrl = useMemo(() => {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(svgContent, 'image/svg+xml');
            const svgElement = doc.querySelector('svg');

            if (!svgElement || doc.querySelector('parsererror')) {
                return null;
            }

            const svgString = new XMLSerializer().serializeToString(svgElement);

            // Use encodeURIComponent instead of btoa for better compatibility
            return `data:image/svg+xml,${encodeURIComponent(svgString)}`;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('SVG parsing error:', error);
            return null;
        }
    }, [svgContent]);

    if (!dataUrl) {
        return (
            <Typography variant="body2" color="error">
                Invalid SVG
            </Typography>
        );
    }

    return (
        <Box
            data-testid="SafeSvgDataRendererComponent"
            sx={{
                maxWidth: width,
                maxHeight: height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width,
                height,
            }}
        >
            <img
                src={dataUrl}
                alt="Logo"
                style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    width: 'auto',
                    height: 'auto',
                }}
            />
        </Box>
    );
};

export default SafeSvgDataRendererComponent;
